<template>
    <div class="w100 container" style="background-color: transparent; margin-bottom: 5px">
      <img v-if="!active" src="/static/images/digit-1.png" srcset="/static/images/digit-1@2x.png"/>
      <img v-if="active" src="/static/images/digit-full-1.png" srcset="/static/images/digit-full-1@2x.png"/>
    </div>
</template>

<script>
    export default {
        name: "digit-v",
      props:['active']
    }
</script>

<style scoped>
  .container {
    /*position: relative;*/
    /*height:20px;*/
    margin: 0;

  }
  img {
    width:100%;
    /*height:35px;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/DigitH.vue